import { FC, useState } from 'react';
import { SCUIContent } from '../../atomic/organisms';
import { SCUIBreadCrumb, SCUITextFieldWithButton } from '../../atomic/molecules';
import { Box, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import './ShippingCompanyLabel.scss';
import { SCUIButton, SCUILoadingLinear } from '../../atomic/atoms';
import { CargoQuery } from '../../services/query';
import Confetti from 'react-confetti';
import Swal from 'sweetalert2';
import { SCL } from './shippingCompanyLabel.classes';

export const ShippingCompanyLabel: FC<any> = () => {
    const [barDisplay, setBarDisplay] = useState(false);
    const { t } = useTranslation();

    const [pdfDataUrl, setPdfDataUrl] = useState<string | null>(null);
    const [orderNo, setOrderNo] = useState('');
    const [showConfetti, setShowConfetti] = useState(false);
    const [inputValue, setInputValue] = useState('');

    const handleSearch = async (shippingListNo: string) => {
        setPdfDataUrl(null);
        setBarDisplay(true);
        try {
            const truncatedShippingListNo = shippingListNo.substring(0, 13);
            setOrderNo(truncatedShippingListNo);
            const req = { shippingListNo: truncatedShippingListNo };
            const response = await CargoQuery.GetShippingCompanyLabel(req);
            if (response?.cargoLabelPdf) {
                const base64String = response.cargoLabelPdf;
                const dataUrl = `data:application/pdf;base64,${base64String}`;
                setPdfDataUrl(dataUrl);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: t('shippingCompanyLabel.error.title'),
                    text: t('shippingCompanyLabel.error.labelNotFound'),
                });
            }
        } catch {
            Swal.fire({
                icon: 'error',
                title: t('shippingCompanyLabel.error.title'),
                text: t('shippingCompanyLabel.error.labelNotFound'),
            });
        } finally {
            setBarDisplay(false);
        }
    };

    const handleConfetti = () => {
        setShowConfetti(true);
        setTimeout(() => setShowConfetti(false), 3000);
    };

    const handleDownload = () => {
        const link: any = document.createElement('a');
        link.href = pdfDataUrl;
        link.download = t('shippingCompanyLabel.downloadFileName', { orderNo });
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        handleConfetti();
    };

    return (
        <SCUIContent className={SCL.page}>
            <Grid container direction="row" className={SCL.root}>
                {showConfetti && (
                    <Confetti
                        className={`confetti-container ${SCL.confetti}`}
                        width={window.innerWidth}
                        height={window.innerHeight}
                    />
                )}
                <Grid container direction="row" className={SCL.inner}>
                    <Box className={SCL.breadcrumb}>
                        <SCUIBreadCrumb
                            title={t('shippingCompanyLabel.title')}
                            componentLink={'ShippingCompanyLabel'}
                        />
                    </Box>
                    <form
                        className={SCL.searchForm}
                        onSubmit={(e) => {
                            e.preventDefault();
                        }}
                    >
                        <SCUITextFieldWithButton
                            paperClassName={SCL.searchBox}
                            inputClassName={SCL.inputShippingNo}
                            iconButtonClassName={SCL.btnSearch}
                            placeholder={t('general.shippingNo')}
                            value={inputValue}
                            onChange={(e: any) => setInputValue(e.target.value)}
                            onClick={() => {
                                handleSearch(inputValue);
                            }}
                            onKeyPress={(e: any) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    handleSearch(inputValue);
                                }
                            }}
                        />
                    </form>
                    <Box className={SCL.loading}>
                        <SCUILoadingLinear display={barDisplay} />
                    </Box>
                    <Grid container className={SCL.preview} sx={{ width: '100%' }}>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            {pdfDataUrl && (
                                <div className={SCL.previewBody} data-shipping-no={orderNo}>
                                    <SCUIButton
                                        className={SCL.btnDownload}
                                        href={pdfDataUrl}
                                        onClick={handleDownload}
                                        type={'primary'}
                                        sizeType={'default'}
                                        size={'s'}
                                        text={t('shippingCompanyLabel.downloadButton')}
                                        style={{ marginTop: '10px', marginBottom: '10px', float: 'right' }}
                                    />
                                    <iframe
                                        className={SCL.previewIframe}
                                        data-shipping-no={orderNo}
                                        src={pdfDataUrl}
                                        style={{
                                            width: '100%',
                                            height: '500px',
                                            border: '1px solid #ccc',
                                        }}
                                        title={t('shippingCompanyLabel.iframeTitle')}
                                    ></iframe>
                                </div>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </SCUIContent>
    );
};
